/**
 * Simplified Chinese strings for the player's own keys.
 *
 * Media Chrome ships this language for its controls; the keys the player adds,
 * casting, preview and its error messages, would otherwise fall back to English.
 */
import { ZhCn as MediaChromeZhCn } from 'media-chrome/lang/zh-CN.js';
import type { TranslateDictionary } from './en.js';

export const ZhCn: TranslateDictionary = {
  ...MediaChromeZhCn,
  'Casting to {device}': '正在投放到 {device}',
  preview: '预览',
  "This video cannot be played on your device because it doesn't meet the content protection requirements.":
    '此视频无法在您的设备上播放，因为设备不满足内容保护要求。',
  'There was an error with the content protection system.':
    '内容保护系统出现错误。',
  'This video requires a secure connection (HTTPS) to play DRM-protected content.':
    '此视频需要安全连接 (HTTPS) 才能播放受 DRM 保护的内容。',
  'An error occurred during playback. The media could not be loaded.':
    '播放过程中出现错误，无法加载媒体。',
  'This video uses a codec (HEVC) that is not supported by your browser. Please try a different browser such as Chrome or Safari.':
    '此视频使用的编解码器 (HEVC) 不受您的浏览器支持。请尝试其他浏览器，例如 Chrome 或 Safari。',
  'There was an error during initialization of the DRM system.':
    '初始化 DRM 系统时出现错误。',
  'The content license has expired.': '内容许可证已过期。',
  'This video is not available.': '此视频不可用。',
  'This video could not be found.': '找不到此视频。',
};
